/**
 * Drain pan creation logic
 */
import { DEFAULT_COEFFICIENTS, SectionCreationContext } from '../../../models/bot';
import { dispatchMutation } from '../../../utils/dispatch.utils';
import { drainPanApi } from '../../../services';

/**
 * Creates a drain pan for a cooling coil section
 */
export async function createDrainPan(
  sectionId: number,
  context: SectionCreationContext
): Promise<any> {
  const { getOptions, onProgress } = context;

  const drainPan = await dispatchMutation(
    drainPanApi.endpoints.createDrainPan,
    {
      body: { section_id: sectionId },
    },
    getOptions()
  );

  onProgress?.(DEFAULT_COEFFICIENTS.drain_pan); // drain_pan coefficient

  return drainPan;
}

